import CheckProduct from './check-a-product';

export default CheckProduct;
